import { createAction } from '@reduxjs/toolkit';

import { ICashItem } from './interfaces';

export interface IEmptyPayload {
  payload: Record<string, never>,
}

export interface IModalOpenGiftPayload {
  payload: {
    isOpen: boolean,
  }
}

export interface IModalOpenGiftTermsPayload {
  payload: {
    isOpenTerms: boolean,
  }
}

export interface IGiftCashLoadData {
  payload: {
    amount: number,
    giftCardId?: number | null,
  }
}

export interface IGiftCashSetData {
  payload: {
    data: ICashItem[],
    amount: number,
  }
}

export interface IGiftCashSelectCard {
  payload: {
    id: number,
  }
}

export interface IGiftCashChangingPayload {
  payload: {
    value: boolean,
  }
}

export const setOpenGift = createAction('GIFT/SET_OPEN', (isOpen = true): IModalOpenGiftPayload => ({
  payload: {
    isOpen,
  },
}));

export const setOpenUseLater = createAction('GIFT/SET_USE_LATER', (isOpen = true): IModalOpenGiftPayload => ({
  payload: {
    isOpen,
  },
}));

export const setOpenGiftTerms = createAction('GIFT/SET_OPEN_TERMS', (isOpenTerms = true): IModalOpenGiftTermsPayload => ({
  payload: {
    isOpenTerms,
  },
}));

export const resetGift = createAction('GIFT/RESET', (isOpen = true): IEmptyPayload => ({
  payload: {},
}));

export interface IModalLoadingGiftPayload {
  payload: {
    isLoading: boolean,
  },
}

export const setLoadingGift = createAction('GIFT/SET_LOADING', (isLoading = true): IModalLoadingGiftPayload => ({
  payload: {
    isLoading,
  },
}));

export const useGift = createAction('GIFT/USE', (): IEmptyPayload => ({
  payload: {},
}));

export interface IModalUseGiftSuccessPayload {
  payload: {
    url: string,
  },
}

export const useGiftSuccess = createAction('GIFT/USE_SUCCESS', (url = true): IModalUseGiftSuccessPayload => ({
  payload: {
    url,
  },
}));

export const useGiftError = createAction('GIFT/USE_ERROR', (): IEmptyPayload => ({
  payload: {},
}));

export interface IModalSetGiftErrorPayload {
  payload: {
    hasError: boolean,
  },
}

export const setGiftError = createAction('GIFT/SET_ERROR', (hasError = true): IModalSetGiftErrorPayload => ({
  payload: {
    hasError,
  },
}));

export const cashLoadData = createAction('GIFT/CASH_LOAD_DATA', (
  amount: number,
  giftCardId?: number | null,
): IGiftCashLoadData => ({
  payload: {
    amount,
    giftCardId,
  },
}));

export const cashSetData = createAction('GIFT/CASH_SET_DATA', (data: ICashItem[], amount: number): IGiftCashSetData => ({
  payload: {
    data,
    amount,
  },
}));

export const cashSelectCard = createAction('GIFT/CASH_SELECT_CARD', (id: number): IGiftCashSelectCard => ({
  payload: {
    id,
  },
}));

export const cashChanging = createAction('GIFT/CASH_CHANGING', (value: boolean): IGiftCashChangingPayload => ({
  payload: {
    value,
  },
}));
